const ARCS = [
  { d: "M17.64 11.53 A14 14 0 0 0 11.53 17.64", color: "#5B52EB" },
  { d: "M30.36 11.53 A14 14 0 0 1 36.47 17.64", color: "#45C4B0" },
  { d: "M36.47 30.36 A14 14 0 0 1 30.36 36.47", color: "#F0964C" },
  { d: "M11.53 30.36 A14 14 0 0 0 17.64 36.47", color: "#E85D45" },
];

export const NuxxumLogo = ({ size = 36, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-label="nuxxum" role="img">
    {ARCS.map((a) => (
      <path key={a.color} d={a.d} stroke={a.color} strokeWidth="10.5" strokeLinecap="round" fill="none" />
    ))}
  </svg>
);

export const NuxxumWordmark = ({ className = "" }) => (
  <span role="img" aria-label="nuxxum"
    className={`font-heading font-extrabold lowercase tracking-tight leading-none inline-flex items-baseline ${className}`}>
    <span>nu</span>
    <svg viewBox="0 0 42 32" style={{ height: "0.6em", width: "auto" }} className="mx-[0.05em] shrink-0" aria-hidden="true">
      <g fill="none" strokeWidth="9" strokeLinecap="round">
        <path d="M4.5 4 L20 27.5" stroke="#6C63F5" />
        <path d="M20 4 L4.5 27.5" stroke="#6C63F5" />
        <path d="M22 4 L37.5 27.5" stroke="#8A83FF" />
        <path d="M37.5 4 L22 27.5" stroke="#8A83FF" />
      </g>
    </svg>
    <span>um</span>
  </span>
);
